import React from 'react';
import { Box, Container, Typography, Link, Divider, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={2} justifyContent="space-between">
          <Grid item xs={12} sm={6}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom>
              Powered by Vercel Blob Storage & Airtable
            </Typography>
            <Typography variant="body2" color="text.secondary">
              This application uses Vercel Blob Storage for secure file storage with SHA-256 verification,
              and Airtable for metadata management and access control.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} sx={{ textAlign: { xs: 'left', sm: 'right' } }}>
            <Typography variant="body2" color="text.secondary">
              © {currentYear} <strong>Web3 Legal Engineering</strong>. All rights reserved.
            </Typography>
            <Box sx={{ mt: 1 }}>
              <Link 
                href="https://terms.freeweb3.com" 
                color="primary"
                sx={{ mr: 2 }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms of Service
              </Link>
              <Link 
                href="https://terms.freeweb3.com" 
                color="primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </Link>
            </Box>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 2 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2 }}>
          <Link
            href="https://vercel.com/docs/storage/vercel-blob"
            target="_blank"
            rel="noopener noreferrer"
            color="text.secondary"
          >
            Vercel Blob Storage
          </Link>
          <Typography color="text.secondary">•</Typography>
          <Link
            href="https://airtable.com"
            target="_blank"
            rel="noopener noreferrer"
            color="text.secondary"
          >
            Airtable
          </Link>
          <Typography color="text.secondary">•</Typography>
          <Link
            href="https://freeweb3.com"
            target="_blank"
            rel="noopener noreferrer"
            color="text.secondary"
          >
            FreeWeb3
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;